module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtTwo.550baa4.png";